import { render, staticRenderFns } from "./UserUpgrades.view.vue?vue&type=template&id=484a7b4f&scoped=true&lang=html&"
import script from "./UserUpgrades.view.vue?vue&type=script&lang=js&"
export * from "./UserUpgrades.view.vue?vue&type=script&lang=js&"
import style0 from "./UserUpgrades.view.vue?vue&type=style&index=0&id=484a7b4f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a7b4f",
  null
  
)

export default component.exports